var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-input"},[_c('label',{attrs:{"for":("input_" + _vm.identifier)}},[_vm._v(" "+_vm._s(_vm.displayName)+" ")]),_c('div',{staticClass:"v-input",attrs:{"id":("input_" + _vm.identifier)}})])}
var staticRenderFns = []

export { render, staticRenderFns }